import { Loader2 } from 'lucide-react';

interface PersonaRegeneratingOverlayProps {
	label?: string;
}

export function PersonaRegeneratingOverlay({ label = 'Regenerating Persona' }: PersonaRegeneratingOverlayProps) {
	return (
		<div className='flex items-start gap-2.5 rounded-[20px] border bg-white p-3'>
			<div className='flex flex-1 flex-col gap-2.5 min-w-0'>
				<div className='flex items-center gap-2'>
					<Loader2 className='size-6 shrink-0 animate-spin text-primary' />
					<p className='text-sm font-medium'>{label}...</p>
				</div>
				<p className='text-xs text-muted-foreground'>
					We're updating the persona based on your feedback. Please hang tight while we make these changes.
				</p>
			</div>
		</div>
	);
}
